import { Metric, onCLS, onFCP, onFID, onINP, onLCP, onTTFB } from 'web-vitals';

import { track } from 'apis/amethyst';
import { WEB_VITAL } from 'constants/amethyst';

type MetricName = 'cls' | 'fcp' | 'lcp' | 'fid' | 'inp' | 'ttfb';

export type WebVitalEvent = { metricName: MetricName; value: Number }; //value accepted as Float in Amethyst.

const evWebVital = ({ metricName, value }: WebVitalEvent) => ({
  [WEB_VITAL]: {
    [metricName]: value
  }
});

const trackMetric = (metric: Metric) => {
  track(() => [evWebVital, { metricName: metric.name.toLowerCase(), value: metric.value } as WebVitalEvent]);
};

export default function reportWebVitals() {
  onCLS(trackMetric);
  onFCP(trackMetric);
  onLCP(trackMetric);
  onFID(trackMetric);
  onINP(trackMetric);
  onTTFB(trackMetric);
}
